var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tower",class:_vm.classes,style:(_vm.style)},[_c('blocks-list',{attrs:{"blocks":_vm.page.blocks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }